import React from 'react';
import { Star, ChevronDown } from 'lucide-react';

interface VisionHeroProps {
    isLoaded: boolean;
}

const VisionHero: React.FC<VisionHeroProps> = ({
    isLoaded,
}) => (
    <div className="max-w-7xl mx-auto text-center px-2 pt-20">
        <div
            className={`transition-all duration-1000 delay-300 ${isLoaded
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-10'
                }`}
        >
            <div className="relative mb-4 sm:mb-8">
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 sm:w-32 sm:h-32 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full opacity-20 animate-ping" />
                </div>
                <Star
                    className="w-12 h-12 sm:w-24 sm:h-24 text-yellow-400 mx-auto animate-spin"
                    style={{ animationDuration: '10s' }}
                />
            </div>
            <h2 className="text-3xl sm:text-5xl md:text-8xl font-black mb-4 sm:mb-8 bg-gradient-to-r from-yellow-400 via-white to-yellow-400 bg-clip-text text-transparent leading-tight">
                VİZYON 2035
            </h2>
            <p className="text-base sm:text-xl text-slate-300 max-w-2xl sm:max-w-4xl mx-auto leading-relaxed mb-6 sm:mb-12">
                Fenerbahçe'nin geleceğe doğru attığı bu tarihi adımda sen de yer
                al.{' '}
                <span className="text-yellow-400 font-semibold">
                    2035 vizyonumuzun bir parçası ol
                </span>{' '}
                ve birlikte yeni zaferler yaşayalım.
            </p>
            <div className="flex justify-center">
                <ChevronDown className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-400 animate-bounce mx-auto" />
            </div>
        </div>
    </div>
);

export default VisionHero; 